import React from "react";
import { connect } from "react-redux";

import { funderContactsSelector, loadingFundersSelector } from "reducers";
import Table, { dateCell, noWrapMultiValueArrayCell } from "components/table";
import IconLink from "../../components/IconLink";
import { FaEdit, FaTrash } from "react-icons/fa";
import { DELETE_FUNDER_CONTACT_MODAL } from "../../components/modals";
import { clearSelectedFunder, showModal } from "../../actions";

const FunderContactsListTable = ({ funderContacts, fundersLoading, ...props }) => {
  const columns = [
    {
      Header: "Action",
      Cell: ({ row }) => {
        const funderContactId = row.original.id;
        console.log(funderContactId);
        return (
          <>
            <IconLink
              to={`/funder_contacts/${funderContactId}/overview/`}
              Icon={FaEdit}
              iconConfig={{ className: "table--action-icon" }}
              tooltip="View / Edit"
              onClick={() => {
                props.clearSelectedFunder();
                window.scrollTo(0, 0);
              }}
            />
            <IconLink
              Icon={FaTrash}
              iconConfig={{ className: "table--action-icon red" }}
              tooltip="Delete Counter Party"
              onClick={() => props.showModal(DELETE_FUNDER_CONTACT_MODAL, { id: funderContactId })}
            />
          </>
        );
      },
    },
    {
      Header: "Name",
      accessor: "name",
      Cell: ({ row }) => {
        if (row.original.first_name && row.original.last_name) {
          return (
            <div className="text-wrap">
              {row.original.last_name}, {row.original.first_name}
            </div>
          );
        } else {
          return "";
        }
      },
    },
    {
      Header: "Title",
      accessor: "title",
      Cell: noWrapMultiValueArrayCell,
    },
    {
      Header: "Counter Parties",
      accessor: "counter_parties_names",
      className: "wrap-text",
      Cell: noWrapMultiValueArrayCell,
    },
    {
      Header: "Counter Parties Market Roles",
      accessor: "counter_parties_market_roles",
      className: "wrap-text",
      Cell: noWrapMultiValueArrayCell,
    },
    {
      Header: "Counter Parties Buying Status",
      accessor: "counter_parties_status",
      className: "wrap-text",
      Cell: noWrapMultiValueArrayCell,
    },
    {
      Header: "Company Phone",
      accessor: "company_phone",
      Cell: noWrapMultiValueArrayCell,
    },
    {
      Header: "Mobile Phone",
      accessor: "mobile_phone",
      className: "padded-table-cells",
    },
    {
      Header: "Company Email",
      accessor: "company_email",
      Cell: noWrapMultiValueArrayCell,
    },
    {
      Header: "Personal Email",
      accessor: "personal_email",
      className: "padded-table-cells",
    },
    {
      Header: "Create Date Date",
      accessor: "date_created",
      Cell: dateCell,
    },
    {
      Header: "Last Edit Date",
      accessor: "last_edit_date",
      Cell: dateCell,
    },
  ];

  return (
    <>
      <Table
        columns={columns}
        data={funderContacts}
        sortBy={[{ id: "name", desc: false }]}
        defaultSort={true}
        showPaginationResults={true}
        initialPageSize={100}
        defaultPagination={true}
        emptyMessage={fundersLoading ? "Loading Counter Party Contacts data..." : "No data"}
      />
    </>
  );
};

const mapStateToProps = state => {
  const contacts = funderContactsSelector(state);
  return {
    funderContacts: funderContactsSelector(state),
    funderContactsLoading: loadingFundersSelector(state),
  };
};

export default connect(mapStateToProps, {
  showModal,
  clearSelectedFunder,
})(FunderContactsListTable);
